import React from 'react';
import {
  ACCOUNT_PLAN_TYPE_OPTIONS,
  ACCOUNT_PLAN_TYPE_COLORS,
  ACCOUNT_PLAN_NATURE,
  ACCOUNT_STATUS,
} from '../../../core/constants/financial';

const getTypeTag = (type) => {
  const colors = ACCOUNT_PLAN_TYPE_COLORS[type] || {};
  const label = ACCOUNT_PLAN_TYPE_OPTIONS.find((o) => o.value === type)?.label || type;
  return (
    <span
      className="fd-type-tag"
      style={{ background: colors.bg, color: colors.color, borderColor: colors.border }}
    >
      {label}
    </span>
  );
};

const AccountPlanTable = ({ accounts, onEdit }) => (
  <div className="fd-modal-table-wrapper">
    <table className="fd-modal-table fd-modal-table--clickable">
      <thead>
        <tr>
          <th style={{ width: 80 }}>Código</th>
          <th>Descrição da Conta</th>
          <th style={{ width: 95, textAlign: 'center' }}>Tipo</th>
          <th style={{ width: 90, textAlign: 'center' }}>Natureza</th>
          <th style={{ width: 70, textAlign: 'center' }}>Status</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map((account) => {
          const isGroup = account.level === 1;
          const isInactive = account.status === ACCOUNT_STATUS.INATIVA;
          const natureLabel = ACCOUNT_PLAN_NATURE[account.type] || '—';
          const natureColor = natureLabel === 'Crédito' ? '#70E000' : '#e88c2a';

          return (
            <tr
              key={account.id}
              onClick={() => onEdit(account)}
              title="Clique para editar"
              style={{
                background: isGroup ? 'rgba(255,255,255,0.025)' : 'transparent',
                opacity: isInactive ? 0.45 : 1,
              }}
            >
              <td style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: isGroup ? 13 : 12,
                fontWeight: 700,
                color: isGroup ? '#fff' : '#ccc',
                padding: isGroup ? '10px 16px' : '8px 16px',
              }}>
                {account.code}
              </td>
              <td style={{
                paddingLeft: isGroup ? 16 : 34,
                fontSize: 12,
                fontWeight: isGroup ? 700 : 400,
                letterSpacing: isGroup ? '0.6px' : 0,
                color: isGroup ? '#fff' : '#ccc',
                borderLeft: isGroup ? 'none' : '2px solid rgba(255,255,255,0.07)',
              }}>
                {!isGroup && <span style={{ color: 'rgba(255,255,255,0.15)', marginRight: 8 }}>└</span>}
                {account.name}
              </td>
              <td style={{ textAlign: 'center' }}>{getTypeTag(account.type)}</td>
              <td style={{ textAlign: 'center', fontSize: 11, fontWeight: 600, color: isGroup ? '#666' : natureColor }}>
                {isGroup ? '—' : natureLabel}
              </td>
              <td style={{ textAlign: 'center' }}>
                <span className={`fd-status-badge fd-status-badge--${account.status === ACCOUNT_STATUS.ATIVA ? 'ativo' : 'inativo'}`}>
                  {account.status === ACCOUNT_STATUS.ATIVA ? 'Ativa' : 'Inativa'}
                </span>
              </td>
            </tr>
          );
        })}
        {accounts.length === 0 && (
          <tr>
            <td colSpan={5} className="fd-table-empty">Nenhuma conta encontrada</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default AccountPlanTable;
